import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import PageLayout from '../components/layout/PageLayout';
import Button from '../components/common/ui/Button';

const NotFoundPage = () => {
  return (
    <PageLayout showSearch={false}>
      <Helmet>
        <title>Page Not Found | NovelDay</title>
        <meta name="robots" content="noindex, nofollow" />
        <meta name="description" content="The page you are looking for does not exist or may have been moved." />
      </Helmet>
      <section className="page-section" style={{ minHeight: '60vh', display: 'grid', placeItems: 'center' }}>
        <div style={{ textAlign: 'center', maxWidth: '32rem', display: 'grid', gap: '1rem' }}>
          <span className="page-kicker">404 Error</span>
          <h1 className="page-title">Page not found</h1>
          <p className="page-subtitle">
            The page you are looking for does not exist or may have been moved.
          </p>
          <div style={{ display: 'flex', gap: '0.75rem', justifyContent: 'center', flexWrap: 'wrap' }}>
            <Link to="/">
              <Button variant="primary">Go Home</Button>
            </Link>
            <Link to="/library">
              <Button variant="outline">Browse Library</Button>
            </Link>
          </div>
        </div>
      </section>
    </PageLayout>
  );
};

export default NotFoundPage;
